var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-header1 my-header flex"},[_c('div',{staticClass:"h-left"}),_c('div',{staticClass:"h-center flex1"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_c('div',{staticClass:"h-right"},[_vm._v("\n        "+_vm._s(_vm.nowDate)+"  "+_vm._s(_vm.nowTime)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }